import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../Button/Button";
import CreateEditOrderModal from "../../Modals/CreateEditOrderModal/CreateEditOrderModal";
import { IPatient } from "../../../interfaces/Patient";
import { IClinician } from "../../../interfaces/Clinician";
import { URLRoutes } from "../../../enums/Routing";

interface ButtonCreateOrderProps {
  className?: string;
  preselectedPatient?: IPatient;
  preselectedClinician?: IClinician;
  onCompleted?: () => void;
}

const ButtonCreateOrder = ({
  preselectedPatient,
  preselectedClinician,
  className,
  onCompleted,
}: ButtonCreateOrderProps) => {
  const [isModalOpened, setIsModalOpened] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleCompleted = (orderId: string) => {
    setIsModalOpened(false);
    onCompleted?.();
    navigate(`${URLRoutes.OrdersDashboard}/${orderId}`);
  };

  return (
    <>
      <Button className={className} onClick={() => setIsModalOpened(true)}>
        Create New Order
      </Button>

      {isModalOpened && (
        <CreateEditOrderModal
          preselectedPatient={preselectedPatient}
          preselectedClinician={preselectedClinician}
          onClose={() => setIsModalOpened(false)}
          onCompleted={handleCompleted}
        />
      )}
    </>
  );
};

export default ButtonCreateOrder;
